import { render, staticRenderFns } from "./btn_novo_funcionario.vue?vue&type=template&id=6e0b297c&"
import script from "./btn_novo_funcionario.vue?vue&type=script&lang=js&"
export * from "./btn_novo_funcionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e0b297c')) {
      api.createRecord('6e0b297c', component.options)
    } else {
      api.reload('6e0b297c', component.options)
    }
    module.hot.accept("./btn_novo_funcionario.vue?vue&type=template&id=6e0b297c&", function () {
      api.rerender('6e0b297c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/painel_apo/btn_novo_funcionario.vue"
export default component.exports